import React, { useState, useEffect } from "react";
import StepCircle from "../StepCircle";
import {
  Typography,
  TextField,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Stepper,
  Step,
  StepLabel,
  Grid,
  OutlinedInput,
  Checkbox,
  ListItemText,
} from "@mui/material";
import api from "../../api";
import { Autocomplete } from "@mui/material";

const steps = ["Datos Básicos", "Licencia", "Asignar Vehículos"];

const AgregarConductor = ({ handleClose, onUpdate }) => {
  const [step, setStep] = useState(0);
  const [conductor, setConductor] = useState({
    nombre: "",
    apellido: "",
    numero_licencia: "",
    categoria_licencia: "",
    vencimiento_licencia: "",
    telefono: "",
    email: "",
    area: "",
    pin: "",
    licencia: null,
    observaciones: "",
    vehiculos_asignados: [],
  });
  const [vehiculos, setVehiculos] = useState([]);
  const [isStep1Valid, setIsStep1Valid] = useState(false);

  useEffect(() => {
    api.get("vehiculos/")
      .then((response) => setVehiculos(response.data))
      .catch(() => alert("Error al cargar vehículos."));
  }, []);

  useEffect(() => {
    const { nombre, apellido, numero_licencia, telefono, email } = conductor;
    setIsStep1Valid(nombre && apellido && numero_licencia);
  }, [conductor]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "licencia") {
      setConductor({ ...conductor, licencia: files[0] });
    } else {
      setConductor({ ...conductor, [name]: value });
    }
  };

  const handleMultiSelectChange = (e) => {
    setConductor({ ...conductor, vehiculos_asignados: e.target.value });
  };

  const handleNext = () => setStep((prev) => prev + 1);
  const handleBack = () => setStep((prev) => prev - 1);

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    for (const key in conductor) {
      if (key === "vehiculos_asignados") {
        conductor[key].forEach((id) => formData.append("vehiculos_asignados", id));
      } else if (key === "licencia" && conductor.licencia) {
        formData.append("licencia", conductor.licencia);
      } else {
        formData.append(key, conductor[key] ?? "");
      }
    }

    if (!conductor.vencimiento_licencia) {
      formData.set("vencimiento_licencia", "");
    }

    api.post("conductores/", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((res) => {
        alert("Conductor agregado correctamente");
        onUpdate?.(res.data);
        handleClose();
      })
      .catch((error) => {
        console.error(error.response?.data || error.message);
        alert("Error: " + JSON.stringify(error.response?.data || "desconocido"));
      });
  };

  return (
    <form onSubmit={handleSubmit} style={{ width: "100%", maxWidth: "600px", margin: "0 auto" }}>
      <Typography variant="h6" style={{ color: "#152d51", fontWeight: "bold" }}>
        Agregar Conductor
      </Typography>
      <Stepper activeStep={step} alternativeLabel>
        {steps.map((label, index) => (
          <Step key={index}>
            <StepLabel StepIconComponent={StepCircle}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {step === 0 && (
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid item xs={6}><TextField label="Nombre" name="nombre" value={conductor.nombre} onChange={handleChange} fullWidth required /></Grid>
          <Grid item xs={6}><TextField label="Apellido" name="apellido" value={conductor.apellido} onChange={handleChange} fullWidth required /></Grid>
          <Grid item xs={6}><TextField label="Número de Licencia" name="numero_licencia" value={conductor.numero_licencia} onChange={handleChange} fullWidth required /></Grid>
          <Grid item xs={6}><TextField label="Categoría Licencia" name="categoria_licencia" value={conductor.categoria_licencia} onChange={handleChange} fullWidth /></Grid>
          <Grid item xs={6}><TextField label="Vencimiento Licencia" name="vencimiento_licencia" type="date" value={conductor.vencimiento_licencia} onChange={handleChange} fullWidth InputLabelProps={{ shrink: true }} /></Grid>
          <Grid item xs={6}><TextField label="Área" name="area" value={conductor.area} onChange={handleChange} fullWidth /></Grid>
          <Grid item xs={6}><TextField label="PIN" name="pin" value={conductor.pin} onChange={handleChange} fullWidth /></Grid>
          <Grid item xs={6}><TextField label="Teléfono" name="telefono" value={conductor.telefono} onChange={handleChange} fullWidth /></Grid>
          <Grid item xs={12}><TextField label="Email" name="email" type="email" value={conductor.email} onChange={handleChange} fullWidth /></Grid>
          <Grid item xs={12}>
            <Button variant="contained" fullWidth onClick={handleNext} sx={{ background: "#152d51" }} disabled={!isStep1Valid}>
              Siguiente
            </Button>
          </Grid>
        </Grid>
      )}

      {step === 1 && (
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid item xs={12}>
            <Button variant="outlined" component="label" fullWidth>
              Subir Licencia (PDF o imagen)
              <input type="file" name="licencia" accept="application/pdf,image/*" hidden onChange={handleChange} />
            </Button>
            {conductor.licencia && (
              <Typography variant="body2" sx={{ mt: 1 }}>
                Archivo seleccionado: {conductor.licencia.name}
              </Typography>
            )}
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Observaciones"
              name="observaciones"
              value={conductor.observaciones}
              onChange={handleChange}
              fullWidth
              multiline
              rows={4}
            />
          </Grid>
          <Grid item xs={6}>
            <Button variant="outlined" fullWidth onClick={handleBack}>
              Atrás
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button variant="contained" fullWidth onClick={handleNext} sx={{ background: "#152d51" }}>
              Siguiente
            </Button>
          </Grid>
        </Grid>
      )}

      {step === 2 && (
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid item xs={12}>
            <Autocomplete
              multiple
              fullWidth
              options={vehiculos}
              getOptionLabel={(option) => `${option.patente} - ${option.marca} ${option.modelo}`}
              value={vehiculos.filter((veh) => conductor.vehiculos_asignados.includes(veh.id))}
              onChange={(event, newValue) => {
                setConductor({
                  ...conductor,
                  vehiculos_asignados: newValue.map((veh) => veh.id),
                });
              }}
              renderInput={(params) => (
                <TextField {...params} label="Vehículos Asignados" placeholder="Buscar vehículo..." />
              )}
              renderOption={(props, option) => (
                <li {...props}>
                  <strong>{option.patente}</strong> — {option.marca} {option.modelo}
                  {option.conductores?.length > 0 && (
                    <Typography variant="caption" sx={{ marginLeft: 1, color: "gray" }}>
                      ({option.conductores.length} asignado/s)
                    </Typography>
                  )}
                </li>
              )}
            />
          </Grid>
          <Grid item xs={6}>
            <Button variant="outlined" fullWidth onClick={handleBack}>
              Atrás
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button type="submit" variant="contained" fullWidth sx={{ background: "#152d51" }}>
              Agregar Conductor
            </Button>
          </Grid>
        </Grid>
      )}
    </form>
  );
};

export default AgregarConductor;
